import Label from '../../../../ui/label'
import Input from '../../../../ui/input'
import { useDispatch } from 'react-redux'
import { customStyle, defaultStyle } from '../../../../../constant/custom-style'
import { setCommissionValue, setServiceValue } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice'
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data'

interface Props {
    isPreview?: boolean
}

export default function ClientInputCommissionAndService({ isPreview }: Props) {

    const dispatch = useDispatch();
    const { commission, services } = useProposalTypeData()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, type: 'commission' | 'serviceCollection') => {
        const value = e.target.value;
        const regex = /^\d{0,2}(\.\d{0,1})?$/;

        if (!regex.test(value) && value !== "") return;

        if (type === "commission") {
            dispatch(setCommissionValue(value === "" ? 0 : Number(value)));
        } else {
            dispatch(setServiceValue(value === "" ? 0 : Number(value)));
        }
    };

    const handleOnBlur = ( e: React.ChangeEvent<HTMLInputElement>, type: 'commission' | 'serviceCollection' ) => {
        let value = e.target.value;

        if (value && !value.includes(".")) {
            value = Number(value).toFixed(1);
        }

        if (type === "commission") {
            dispatch(setCommissionValue(value ? Number(value) : 0));
        } else {
            dispatch(setServiceValue(value ? Number(value) : 0));
        }
    };

    return (
        <div className="overflow-hidden rounded-xl">
            {/* Header */}
            <div className="flex items-start gap-2.5 border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-3 py-3 sm:px-4">
                <div>
                    <Label
                        label="Commission & Service Charges"
                        fontSize="text-xs"
                        fontWeight="font-semibold text-gray-800"
                    />
                    <p className="mt-1 text-[11px] leading-4 text-gray-500 sm:text-xs">
                        Specify the commission rate and service/collection fee.
                    </p>
                </div>
            </div>
            {/* Body */}
            <div className="bg-white p-4">
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    {/* Commission */}
                    <div className="space-y-1.5">
                        <Label
                            label="Commission Rate"
                            fontSize="text-xs"
                            fontWeight="font-semibold"
                        />
                        <div className="relative">
                            <Input
                                type="text"
                                name="commission"
                                value={commission ?? ''}
                                isCustomStyle
                                customCss={`pr-8 ${defaultStyle} ${commission != null ? customStyle : '' }`}
                                onChange={(e) => handleChange(e, 'commission') }
                                onBlur={(e) => handleOnBlur(e, 'commission') }
                                placeholder="0-50"
                                disabled={isPreview}
                            />
                            <span className="pointer-events-none absolute inset-y-0 right-2.5 flex items-center text-xs font-medium text-gray-500">
                                %
                            </span>
                        </div>
                    </div>
                    {/* Service / Collection Fee */}
                    <div className="space-y-1.5">
                        <Label
                            label="Service / Collection Fee"
                            fontSize="text-xs"
                            fontWeight="font-semibold"
                        />
                        <div className="relative">
                            <Input
                                type="text"
                                name="serviceCollection"
                                value={services ?? ''}
                                isCustomStyle
                                customCss={`pr-8 ${defaultStyle} ${ services != null ? customStyle : '' }`}
                                onChange={(e) => handleChange(e, 'serviceCollection')}
                                onBlur={(e) => handleOnBlur(e, 'serviceCollection')}
                                placeholder="0-50"
                                disabled={isPreview}
                            />
                            <span className="pointer-events-none absolute inset-y-0 right-2.5 flex items-center text-xs font-medium text-gray-500">
                                %
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex items-start gap-2 py-2.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 shrink-0 text-amber-500" >
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12.01" y2="8" />
                        <line x1="12" y1="12" x2="12" y2="16" />
                    </svg>
                    <p className="text-[10px] leading-4 text-gray-500 sm:text-[11px]">
                        Accepts a value between{' '}
                        <span className="font-semibold text-gray-700">0</span> and{' '}
                        <span className="font-semibold text-gray-700">50</span>.
                    </p>
                </div>
            </div>
        </div>
    );
}